/* Devil Daves - Sticky Add to Cart (sticky-template-2026)
   Pairs with snippets/dd-sticky-atc.liquid and assets/dd-sticky-atc.css.

   What it does:
   1. Waits for the Kaching deal block to finish loading.
   2. Inserts a proxy Add to Cart button between Kaching's variant cells
      (.kaching-bundles__bars) and its checkbox upsells.
   3. Mirrors Dawn's real submit button (text, disabled, loading) onto the proxy
      and forwards clicks to the real button so Dawn + Kaching behave as normal.
   4. Keeps the sticky top offset clear of the site header.
   5. Optionally boots Lenis smooth scrolling.

   The real button is hidden by CSS (product-info.dd-sticky-active). Buy with
   Shop is never moved. */

(function () {
  'use strict';

  if (window.__ddStickyAtcLoaded) return;
  window.__ddStickyAtcLoaded = true;

  var SELECTORS = {
    kachingBlock: '.kaching-bundles__block',
    kachingBars: '.kaching-bundles__bars',
    kachingUpsells: '.kaching-bundles__checkbox-upsells',
    realButton: '.product-form__buttons > .product-form__submit',
    header: '.shopify-section-header, .shopify-section-group-header-group'
  };

  function StickyAtc(root) {
    this.root = root;
    this.sectionId = root.dataset.section;
    this.topOffset = parseInt(root.dataset.topOffset, 10) || 0;
    this.shadow = root.dataset.shadow !== 'false';
    this.info = root.closest('product-info') || document.getElementById('ProductInfo-' + this.sectionId);
    this.wrap = null;
    this.proxy = null;
    this.label = null;
    this.spinner = null;
    this.rafPending = false;
    this.syncPending = false;

    if (!this.info) return;

    this.onScroll = this.onScroll.bind(this);
    this.onClick = this.onClick.bind(this);
    this.requestSync = this.requestSync.bind(this);

    this.waitForKaching();
  }

  StickyAtc.prototype.getReal = function () {
    return this.info.querySelector(SELECTORS.realButton);
  };

  StickyAtc.prototype.getKaching = function () {
    var block = this.info.querySelector(SELECTORS.kachingBlock);
    if (!block) return null;
    var bars = block.querySelector(SELECTORS.kachingBars);
    var upsells = block.querySelector(SELECTORS.kachingUpsells);
    if (!bars) return null;
    return { block: block, bars: bars, upsells: upsells };
  };

  /* Kaching renders asynchronously. Poll the DOM via MutationObserver until
     the block, its bars and the real button all exist, then mount. */
  StickyAtc.prototype.waitForKaching = function () {
    var self = this;
    if (this.getKaching() && this.getReal()) {
      this.mount();
      return;
    }
    var observer = new MutationObserver(function () {
      if (self.getKaching() && self.getReal()) {
        observer.disconnect();
        self.mount();
      }
    });
    observer.observe(this.info, { childList: true, subtree: true });

    /* Safety valve: stop watching after 15s if Kaching never shows up.
       The page just keeps Dawn's native button. */
    setTimeout(function () {
      observer.disconnect();
    }, 15000);
  };

  StickyAtc.prototype.buildProxy = function () {
    var tpl = this.root.querySelector('template');
    var frag = tpl.content.cloneNode(true);
    this.wrap = frag.querySelector('.dd-sticky-atc__wrap');
    this.proxy = frag.querySelector('.dd-sticky-atc__btn');
    this.label = frag.querySelector('.dd-sticky-atc__label');
    this.spinner = frag.querySelector('.loading__spinner');
    if (this.shadow) this.wrap.classList.add('has-shadow');
    this.proxy.addEventListener('click', this.onClick);
  };

  /* Insert (or re-insert) the proxy directly after Kaching's variant cells. */
  StickyAtc.prototype.place = function () {
    var k = this.getKaching();
    if (!k || !this.wrap) return false;
    if (this.wrap.parentNode === k.block && k.bars.nextElementSibling === this.wrap) return true;
    k.bars.insertAdjacentElement('afterend', this.wrap);
    return true;
  };

  StickyAtc.prototype.mount = function () {
    var self = this;
    if (this.wrap) return;

    this.buildProxy();
    if (!this.place()) return;

    this.info.classList.add('dd-sticky-active');
    this.sync();

    /* Mirror the real button whenever Dawn or Kaching change it,
       and re-place the proxy if Kaching redraws its block. */
    this.observer = new MutationObserver(function (mutations) {
      var needsPlace = false;
      for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].type === 'childList') {
          needsPlace = true;
          break;
        }
      }
      if (needsPlace) self.place();
      self.requestSync();
    });
    this.observer.observe(this.info, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['disabled', 'aria-disabled', 'class'],
      characterData: true
    });

    window.addEventListener('scroll', this.onScroll, { passive: true });
    window.addEventListener('resize', this.onScroll, { passive: true });
    this.onScroll();
  };

  StickyAtc.prototype.requestSync = function () {
    var self = this;
    if (this.syncPending) return;
    this.syncPending = true;
    window.requestAnimationFrame(function () {
      self.syncPending = false;
      self.sync();
    });
  };

  /* Copy state from the real button onto the proxy. */
  StickyAtc.prototype.sync = function () {
    var real = this.getReal();
    if (!real || !this.proxy) return;

    var realLabel = real.querySelector('span');
    if (realLabel) {
      var text = realLabel.textContent.replace(/\s+/g, ' ').trim();
      if (text && this.label.textContent !== text) this.label.textContent = text;
    }

    var disabled = real.disabled || real.getAttribute('aria-disabled') === 'true';
    var loading = real.classList.contains('loading');

    if (disabled && !loading) {
      this.proxy.setAttribute('aria-disabled', 'true');
    } else {
      this.proxy.removeAttribute('aria-disabled');
    }
    this.proxy.disabled = !!real.disabled;

    if (loading) {
      this.proxy.classList.add('loading');
      this.spinner.classList.remove('hidden');
    } else {
      this.proxy.classList.remove('loading');
      this.spinner.classList.add('hidden');
    }

    /* Keep Dawn's primary/secondary styling in step with the real button,
       and mirror the bundle gate's grey blocked state when that snippet is on */
    this.proxy.classList.toggle('button--primary', real.classList.contains('button--primary'));
    this.proxy.classList.toggle('button--secondary', real.classList.contains('button--secondary'));
    this.proxy.classList.toggle('bundle-gate-blocked', real.classList.contains('bundle-gate-blocked'));
  };

  StickyAtc.prototype.onClick = function (event) {
    event.preventDefault();
    var real = this.getReal();
    if (!real) return;
    if (real.disabled || real.getAttribute('aria-disabled') === 'true') return;
    /* A programmatic click on the real submit button fires the form's submit
       event, so Dawn's AJAX add-to-cart and Kaching's upsell logic both run. */
    real.click();
  };

  /* Sticky header offset + pinned state, throttled to one read per frame. */
  StickyAtc.prototype.onScroll = function () {
    var self = this;
    if (this.rafPending) return;
    this.rafPending = true;
    window.requestAnimationFrame(function () {
      self.rafPending = false;
      self.updateOffset();
    });
  };

  StickyAtc.prototype.updateOffset = function () {
    if (!this.wrap) return;

    var headerBottom = 0;
    var header = document.querySelector(SELECTORS.header);
    if (header) {
      var pos = window.getComputedStyle(header).position;
      if (pos === 'sticky' || pos === 'fixed') {
        var rect = header.getBoundingClientRect();
        if (rect.bottom > 0) headerBottom = rect.bottom;
      }
    }

    var top = Math.round(headerBottom + this.topOffset);
    this.wrap.style.setProperty('--dd-sticky-top', top + 'px');

    /* Pinned = riding at the sticky offset. Once it lands above Buy with Shop
       and scrolls away with the page, the shadow comes off. */
    var wrapTop = this.wrap.getBoundingClientRect().top;
    var pinned = Math.abs(wrapTop - top) <= 1;
    this.wrap.classList.toggle('is-pinned', pinned);
  };

  /* Lenis smooth scroll. Native scroll is kept, so position: sticky works. */
  function bootLenis() {
    if (window.__ddLenis) return;
    if (typeof window.Lenis !== 'function') return;
    if (window.Shopify && window.Shopify.designMode) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    /* Drawers and modals scroll on their own, so Lenis must leave them alone. */
    var preventSelectors = [
      'cart-drawer',
      'menu-drawer',
      'header-drawer',
      'product-media-modal',
      'modal-dialog',
      'predictive-search',
      'quick-add-modal',
      '.drawer__inner',
      '.cart-drawer__inner'
    ];
    document.querySelectorAll(preventSelectors.join(',')).forEach(function (el) {
      el.setAttribute('data-lenis-prevent', '');
    });

    try {
      window.__ddLenis = new window.Lenis({
        autoRaf: true,
        lerp: 0.1,
        smoothWheel: true,
        anchors: true
      });
    } catch (err) {
      window.__ddLenis = null;
    }
  }

  function init() {
    var roots = document.querySelectorAll('.dd-sticky-atc');
    var wantLenis = false;
    roots.forEach(function (root) {
      if (root.__ddStickyAtc) return;
      root.__ddStickyAtc = new StickyAtc(root);
      if (root.dataset.lenis === 'true') wantLenis = true;
    });
    if (wantLenis) bootLenis();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Theme editor: re-run when the section is reloaded */
  document.addEventListener('shopify:section:load', init);
})();
